//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
export default {
  components: { work_bench_item },
  data() {
    return {
      pageData: {},
      actionTitle:'',
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: '选择盘库方式',
        actions: [
          { name: '销售区域', url:'http://ysl.entfly.com/mCm/SalesArea' },
          { name: '销管人员', url:'http://ysl.entfly.com/mCm/SalesUser' },
        ],
      },
      actionSheet2: {
        title: '选择操作',
        actions: [
          { name: '经销商列表', url:'http://ysl.entfly.com/mCm/SalesDealer' },
          { name: '经销商库存', url:'http://ysl.entfly.com/mCm/DealerStockData/DealerIndex' },
        ],
      },
      actionSheet3: {
        title: '选择操作',
        actions: [
          { name: '门店列表', url:'http://ysl.entfly.com/mCm/SalesShop' },
          { name: '门店库存', url:'http://ysl.entfly.com/mCm/ShopStockData/ShopIndex' },
        ],
      },
      actionSheet4: {
        title: '选择操作',
        actions: [
          { name: '门店人员', url:'' },
          { name: '导购人员', url:'' },
        ],
      },
      actionSheet5: {
        title: '选择操作',
        actions: [
          { name: '我的金额', url:'http://ysl.entfly.com/mCc/PassageUserCashInOrder/Index' },
          { name: '金额记录', url:'http://ysl.entfly.com/mCc/PassageUserCashDataLog/Index' },
        ],
      },
      work_bench_item1: [
        {
          img: "images/1_15.png",
          text: "销售",
          action: 'stockCount'
        },
      ],
      work_bench_item2: [
        {
          img: "images/3_03.png",
          text: "经销商",
          action: 'chooseDealer'
        },
        {
          img: "images/31_11.png",
          text: "门店",
          action: 'chooseShop',
          hide_border: true
        },
        {
          img: "images/31_11.png",
          text: "门店人员",
          action: 'choosePerson',
        },
      ],
      work_bench_item3: [
        {
          img: "images/20_03.png",
          text: "会员列表",
          link: this.$api.host+"/mCM/Member/Index?from=home",
        },
        {
          img: "images/20_03.png",
          text: "新客活动",
          link: this.$api.host+"/mCM/NewCustomerActivity/Index?from=home",
        },
      ],
      work_bench_item4: [
        {
          img: "images/31_07.png",
          text: "我的金额",
          action: 'chooseSum',
        },
      ],
    };
  },
  computed: {},

  created () {
    this.$wxConfig()
    this.$http({
      url: this.$api.GetPassageUserInfo,
      method: 'post'
    }).then(res => {
      if (res.data.state == 1) {
        this.pageData = res.data.data
      }
    })
  },

  methods: {
    goGuideRightsPage () {
      this.$router.push('/mGms/guideRights')
    },
    goPage (link) {
      if (link) {
        // wx.navigateTo({ url: link })
        if (link.indexOf('http') == -1) {
          this.$router.push(link)
        } else {
          window.location = link
          this.$toast({
            type: 'loading',
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '加载中'
          })
        }
      }
    },
    stockCount () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet1.title
      this.actionList = this.actionSheet1.actions
    },
    chooseDealer () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet2.title
      this.actionList = this.actionSheet2.actions
    },
    chooseShop () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet3.title
      this.actionList = this.actionSheet3.actions
    },
    choosePerson () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet4.title
      this.actionList = this.actionSheet4.actions
    },
    chooseSum () {
      this.showActionSheet = true
      this.actionTitle = this.actionSheet5.title
      this.actionList = this.actionSheet5.actions
    },
    onSelect (item) {
      console.log(item)
      if (item.url) {
        if (item.url.indexOf('http') == -1) {
          this.$router.push(item.url)
        } else {
          window.location = item.url
          this.$toast({
            type: 'loading',
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '加载中'
          })
        }
      }
    },
    onClickScanBtn () {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log('开始扫码', res1)
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
